import { useNavigate, useParams } from "react-router-dom";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { AppleIcon, Avatar, CardInner, GoogleIcon, MainWrapper, Name, ProfileCard, StoreButton, StoreButtonDisabled, StoreButtons, StoreText, StoreTextSmall, StoreTextStrong, Subtitle } from "./styled";
import { getUser } from "../api";
import { UserResponse } from "../api/types";
import { useSignedMediaSrc } from "@shared/lib/use-signed-media-src";

export const Profile: FC = () => {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const [user, setUsers] = useState<UserResponse>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [refreshToggle, setRefreshToggle] = React.useState(false);
  const hasUserRef = useRef(false);

  const refreshUser = useCallback(() => setRefreshToggle((value) => !value), []);

  const { src: photoSrc, onError: onPhotoError } = useSignedMediaSrc({
    url: user?.photo?.url,
    refresh: refreshUser,
  });

  useEffect(() => {
    hasUserRef.current = false;
  }, [id]);

  useEffect(() => {
    // Лоадер только на первой загрузке: на перезапросе за свежей ссылкой
    // карточка не должна мигать.
    if (!hasUserRef.current) {
      setLoading(true);
    }

    getUser(id)
      .then((data) => {
        hasUserRef.current = true;
        setUsers(data);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [refreshToggle, id]);

  return (
    <MainWrapper>
      <ProfileCard>
        {!loading && (
          <CardInner>
            {user?.photo && (
              <Avatar src={photoSrc} alt="Фото пользователя" onError={onPhotoError} />
            )}

            <Name>{user?.name}</Name>

            <Subtitle>Приглашает вас в Plumme!</Subtitle>
            <Subtitle>Закрытое клубное  пространство</Subtitle>
            <Subtitle>Объединяющее людей через клубы по интересам для нетворкинга и досуга.</Subtitle>

            <StoreButtons>
              <StoreButtonDisabled href="https://apps.apple.com/ru/app/plumme/id6759450972">
                <AppleIcon
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="apple"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 384 512"
                >
                  <path
                    fill="currentColor"
                    d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                  />
                </AppleIcon>
                <StoreText>
                  <StoreTextSmall style={{ fontSize: '12px' }}
                                  onClick={() =>
                                          navigate(
                                            `https://apps.apple.com/ru/app/plumme/id6759450972`
                                          )
                                        }
                                    >
                    Загрузите</StoreTextSmall>
                  <StoreTextStrong>в App Store</StoreTextStrong>
                </StoreText>
              </StoreButtonDisabled>

              {/*<StoreButton href="#">*/}
              {/*  <GoogleIcon*/}
              {/*    aria-hidden="true"*/}
              {/*    xmlns="http://www.w3.org/2000/svg"*/}
              {/*    width="24"*/}
              {/*    height="24"*/}
              {/*    fill="currentColor"*/}
              {/*    viewBox="0 0 24 24"*/}
              {/*  >*/}
              {/*    <path*/}
              {/*      fillRule="evenodd"*/}
              {/*      d="M5 8a4 4 0 1 1 7.796 1.263l-2.533 2.534A4 4 0 0 1 5 8Zm4.06 5H7a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h2.172a2.999 2.999 0 0 1-.114-1.588l.674-3.372a3 3 0 0 1 .82-1.533L9.06 13Zm9.032-5a2.907 2.907 0 0 0-2.056.852L9.967 14.92a1 1 0 0 0-.273.51l-.675 3.373a1 1 0 0 0 1.177 1.177l3.372-.675a1 1 0 0 0 .511-.273l6.07-6.07a2.91 2.91 0 0 0-.944-4.742A2.907 2.907 0 0 0 18.092 8Z"*/}
              {/*      clipRule="evenodd"*/}
              {/*    />*/}
              {/*  </GoogleIcon>*/}

              {/*  {user?.invite_code && (*/}
              {/*    <StoreText*/}
              {/*      onClick={() =>*/}
              {/*        navigate(*/}
              {/*          `/?invite_code=${encodeURIComponent(*/}
              {/*            user.invite_code*/}
              {/*          ).toLowerCase()}`*/}
              {/*        )*/}
              {/*      }*/}
              {/*    >*/}
              {/*      <StoreTextSmall>Регистрация</StoreTextSmall>*/}
              {/*      <StoreTextStrong>здесь</StoreTextStrong>*/}
              {/*    </StoreText>*/}
              {/*  )}*/}
              {/*</StoreButton>*/}
            </StoreButtons>
          </CardInner>
        )}
      </ProfileCard>
    </MainWrapper>
  );
}
